// Shared modals, banners and widgets
const components = {
  // Onboarding
  'Please enter a valid phone number.': 'يُرجى إدخال رقم هاتف صحيح.',
  'Setting up your experience...': 'جارٍ تجهيز تجربتك...',
  'Just a moment while we personalize ArabCap for you.': 'لحظة واحدة، نحن نجهّز ArabCap لك.',
  "What's your phone number?": 'ما رقم هاتفك؟',
  'Search country...': 'ابحث عن الدولة...',
  'Other Countries': 'دول أخرى',
  'Phone number': 'رقم الهاتف',
  'Join our community and receive exclusive offers': 'انضم إلى مجتمعنا واحصل على عروض حصرية',
  'Saving...': 'جارٍ الحفظ...',
  "We'll never share your number with third parties": 'لن نشارك رقمك مع أي جهة أخرى',
  'What best describes your role?': 'ما الذي يصف عملك بشكل أفضل؟',
  'We will personalize your experience based on this.': 'سنخصّص تجربتك بناءً على إجابتك.',
  'Solo Creator': 'صانع محتوى مستقل',
  'Agency / Studio': 'وكالة / استوديو',
  'Brand / Business': 'علامة تجارية / شركة',
  'Other': 'أخرى',
  'How many videos do you subtitle monthly?': 'كم فيديو تترجم شهريًا؟',
  'This helps us ensure enough capacity for your projects.': 'يساعدنا هذا على توفير ما يكفي لمشاريعك.',
  '1 - 3 videos': '1 - 3 فيديوهات',
  '4 - 10 videos': '4 - 10 فيديوهات',
  '11 - 25 videos': '11 - 25 فيديو',
  '25+ videos': 'أكثر من 25 فيديو',
  'What is your primary video format?': 'ما الصيغة الأساسية لفيديوهاتك؟',
  'Short-form content is our specialty.': 'المحتوى القصير هو تخصصنا.',
  'Vertical (Shorts/Reels)': 'عمودي (Shorts/Reels)',
  'Horizontal (YouTube)': 'أفقي (YouTube)',
  'Both equally': 'الاثنان بالتساوي',
  'Which editing tool do you use?': 'ما برنامج المونتاج الذي تستخدمه؟',
  "We'll optimize your workflow for your favorite tool.": 'سنهيّئ طريقة العمل لتناسب برنامجك المفضل.',

  // Phone verification
  'To Export for Free, Verify Your Number': 'للتصدير مجانًا، أكّد رقمك',
  'To export for free, please verify your number on WhatsApp. You can also skip verification and upgrade your plan.':
    'للتصدير مجانًا، يُرجى تأكيد رقمك عبر واتساب. يمكنك أيضًا تخطي التأكيد وترقية باقتك.',
  'Not set': 'غير محدد',
  'Edit': 'تعديل',
  'Sending...': 'جارٍ الإرسال...',
  'Verify Number': 'تأكيد الرقم',
  'Skip Verification & Upgrade': 'تخطي التأكيد والترقية',
  'Update Phone Number': 'تحديث رقم الهاتف',
  'Same style as onboarding, optimized for mobile.': 'أدخل رقم الهاتف الذي تريد استخدامه.',
  'Search country or code...': 'ابحث عن الدولة أو الرمز...',
  'Enter your number with or without leading 0': 'أدخل رقمك مع الصفر في البداية أو بدونه',
  'Cancel': 'إلغاء',
  'Enter Verification Code': 'أدخل رمز التأكيد',
  'We sent a 6-digit code via WhatsApp to': 'أرسلنا رمزًا من 6 أرقام عبر واتساب إلى',
  'Resend in {seconds}s': 'إعادة الإرسال بعد {seconds} ث',
  'Resend Code': 'إعادة إرسال الرمز',
  'Contact Support on WhatsApp': 'تواصل مع الدعم على واتساب',
  'Updating...': 'جارٍ التحديث...',
  'Update Number': 'تحديث الرقم',
  'Verifying...': 'جارٍ التحقق...',
  'Verify Code': 'تأكيد الرمز',
  'Failed to send OTP': 'تعذّر إرسال الرمز',
  'Failed to send OTP. Please try again.': 'تعذّر إرسال الرمز. حاول مرة أخرى.',
  'You have used all your resend attempts. Please contact support for help.': 'لقد استنفدت جميع محاولات إعادة الإرسال. يُرجى التواصل مع الدعم.',
  'Failed to update phone number': 'تعذّر تحديث رقم الهاتف',
  'Invalid OTP code': 'رمز التأكيد غير صحيح',
  'Invalid or expired OTP code': 'رمز التأكيد غير صحيح أو منتهي الصلاحية',

  // Suspended account
  'Failed to start checkout. Please try again.': 'تعذّر بدء عملية الدفع. حاول مرة أخرى.',
  'Account Suspended': 'تم تعليق الحساب',
  'Your account has been suspended due to unusual activity detected on your account.': 'تم تعليق حسابك بسبب نشاط غير معتاد تم رصده عليه.',
  'If you believe this is a mistake or would like to discuss this matter, please contact our support team.':
    'إذا كنت تعتقد أن هذا خطأ أو تريد مناقشة الأمر، يُرجى التواصل مع فريق الدعم.',
  'Upgrade to a paid plan to instantly unblock your account, or contact our support team.':
    'اشترك في باقة مدفوعة لإلغاء حظر حسابك فورًا، أو تواصل مع فريق الدعم.',
  'Upgrade to Unblock': 'اشترك لإلغاء الحظر',
  'We typically respond within a few hours': 'نرد عادةً خلال ساعات قليلة',
  'Choose a plan and your account will be automatically unblocked': 'اختر باقة وسيُلغى حظر حسابك تلقائيًا',
  'Instant unblock': 'إلغاء حظر فوري',

  // Welcome offer
  '{amount} MAD': '{amount} درهم',
  'First month · {percent}% off': 'الشهر الأول · خصم {percent}%',
  'Then {price}/month': 'ثم {price} شهريًا',
  'Checkout is unavailable. Please try again.': 'الدفع غير متاح حاليًا. حاول مرة أخرى.',
  'Unable to open checkout. Please try again.': 'تعذّر فتح صفحة الدفع. حاول مرة أخرى.',
  'Your welcome offer': 'عرض الترحيب الخاص بك',
  'JUST JOINED': 'انضممت للتو',
  'Your first month, {percent}% off.': 'شهرك الأول بخصم {percent}%.',
  'PRO & MAX · One welcome offer. Start checkout before time runs out.': 'PRO وMAX · عرض ترحيبي واحد. ابدأ الدفع قبل انتهاء الوقت.',
  'Claim within': 'احصل عليه خلال',
  '{seconds} seconds left to claim': 'متبقٍ {seconds} ثانية للحصول على العرض',
  'Unlock my offer': 'احصل على العرض',
  'Close welcome offer': 'إغلاق عرض الترحيب',
  'YOUR WELCOME OFFER': 'عرض الترحيب الخاص بك',
  'Make your first month count. Save {percent}%.': 'اجعل شهرك الأول مميزًا. وفّر {percent}%.',
  'Your welcome offer has ended.': 'انتهى عرض الترحيب الخاص بك.',
  'Start checkout within <b>{timer}</b> to claim. Your discount is applied automatically.':
    'ابدأ الدفع خلال <b>{timer}</b> للحصول على العرض. يُطبَّق الخصم تلقائيًا.',
  '{count} videos per month': '{count} فيديو شهريًا',
  'Opening checkout…': 'جارٍ فتح صفحة الدفع…',
  'Choose {plan}': 'اختر {plan}',
  'First month only. Renews at the regular monthly price shown above. Cancel anytime in Settings. Once claimed, you have 30 minutes to complete Stripe checkout.':
    'للشهر الأول فقط. يتجدد الاشتراك بالسعر الشهري العادي الموضح أعلاه. يمكنك الإلغاء في أي وقت من الإعدادات. بعد المطالبة بالعرض، لديك 30 دقيقة لإتمام الدفع عبر Stripe.',
  'This one-time offer does not restart. You can still explore PRO and MAX in Settings.':
    'هذا العرض لمرة واحدة ولا يتجدد. لا يزال بإمكانك الاطلاع على باقتي PRO وMAX من الإعدادات.',

  // Time saved card
  'minutes (unit)': { zero: 'دقيقة', one: 'دقيقة', two: 'دقيقة', few: 'دقائق', many: 'دقيقة', other: 'دقيقة' },
  'hours (unit)': { zero: 'ساعة', one: 'ساعة', two: 'ساعة', few: 'ساعات', many: 'ساعة', other: 'ساعة' },
  '{hours}h {minutes}m': '{hours} س {minutes} د',
  "That's {count} coffee breaks": {
    zero: 'أي أقل من استراحة قهوة',
    one: 'أي ما يعادل استراحة قهوة واحدة',
    two: 'أي ما يعادل استراحتَي قهوة',
    few: 'أي ما يعادل {count} استراحات قهوة',
    many: 'أي ما يعادل {count} استراحة قهوة',
    other: 'أي ما يعادل {count} استراحة قهوة',
  },
  "That's like watching {count} full football matches": {
    zero: 'كأنك شاهدت جزءًا من مباراة كرة قدم',
    one: 'كأنك شاهدت مباراة كرة قدم كاملة',
    two: 'كأنك شاهدت مباراتَي كرة قدم كاملتين',
    few: 'كأنك شاهدت {count} مباريات كرة قدم كاملة',
    many: 'كأنك شاهدت {count} مباراة كرة قدم كاملة',
    other: 'كأنك شاهدت {count} مباراة كرة قدم كاملة',
  },
  "That's {count} full work days you didn't spend captioning": {
    zero: 'وقت لم تقضه في كتابة الترجمة',
    one: 'أي يوم عمل كامل لم تقضه في كتابة الترجمة',
    two: 'أي يومَي عمل كاملين لم تقضهما في كتابة الترجمة',
    few: 'أي {count} أيام عمل كاملة لم تقضها في كتابة الترجمة',
    many: 'أي {count} يوم عمل كامل لم تقضها في كتابة الترجمة',
    other: 'أي {count} يوم عمل كامل لم تقضها في كتابة الترجمة',
  },
  '{count} videos · vs. captioning by hand (~{rate} min per video minute)':
    '{count} فيديو · مقارنة بالكتابة اليدوية (~{rate} دقائق لكل دقيقة فيديو)',
  'Time saved with ArabCap': 'الوقت الذي وفّرته مع ArabCap',

  // Partner offers
  'See website': 'زيارة الموقع',
  'Partner offers': 'عروض الشركاء',
  'Previous partner offer': 'العرض السابق',
  'Show {name} offer': 'عرض {name}',
  'Next partner offer': 'العرض التالي',
  'Exclusive partner offer': 'عرض حصري من شريكنا',
  'Creator gear perks available': 'مزايا على معدات صنّاع المحتوى',
  'Cinema gear perks available': 'مزايا على معدات التصوير السينمائي',
  'Message us to unlock your partner code': 'راسلنا للحصول على رمز الشريك',
  'For cameras, mics, phones and creator accessories.': 'للكاميرات والميكروفونات والهواتف وإكسسوارات صنّاع المحتوى.',
  'For cinema cameras, lenses, lighting and studio gear.': 'للكاميرات السينمائية والعدسات والإضاءة ومعدات الاستوديو.',
  'Get access': 'احصل عليه',
  "Hi! I'm an ArabCap creator and I'd like the YourTech partner code for creator gear.":
    'مرحبًا! أنا من مستخدمي ArabCap وأرغب في الحصول على رمز شريك YourTech لمعدات صنّاع المحتوى.',
  "Hi! I'm an ArabCap creator and I'd like the Wina Shop partner code for camera and video gear.":
    'مرحبًا! أنا من مستخدمي ArabCap وأرغب في الحصول على رمز شريك Wina Shop لمعدات التصوير والفيديو.',

  // WhatsApp button
  'Join Our Community': 'انضم إلى مجتمعنا',
  'Need Help?': 'تحتاج مساعدة؟',
  'WhatsApp Menu': 'قائمة واتساب',
  'Hi, I need help with...': 'مرحبًا، أحتاج مساعدة في...',

  // Premiere Pro extension (editor card + dashboard card)
  'ArabCap for Premiere Pro': 'ArabCap لبرنامج Premiere Pro',
  'Caption inside Premiere Pro': 'أضف الترجمة داخل Premiere Pro',
  'Free extension · captions straight on your timeline': 'إضافة مجانية · الترجمة مباشرة على الخط الزمني',
  'Download for {os}': 'تحميل لنظام {os}',
  'See more': 'اعرف المزيد',
  'New · Premiere Pro extension': 'جديد · إضافة Premiere Pro',
  'ArabCap is now inside Premiere Pro': 'ArabCap الآن داخل Premiere Pro',
  'Pick a clip, choose the dialect, and get your captions without leaving Premiere. No exporting, no SRT files to import.':
    'اختر المقطع، حدّد اللهجة، واحصل على الترجمة دون مغادرة Premiere. بدون تصدير وبدون ملفات SRT لاستيرادها.',
  'Captions land on your timeline, at the start of your clip': 'تُضاف الترجمة إلى الخط الزمني عند بداية المقطع',
  'Only the audio is uploaded, so long clips start fast': 'يُرفع الصوت فقط، فتبدأ المقاطع الطويلة بسرعة',
  'Same account, plan and credits as here': 'نفس الحساب والباقة والرصيد المستخدمة هنا',
  'Get the extension': 'احصل على الإضافة',
  'Also available for {os}': 'متوفرة أيضًا لنظام {os}',
  'ArabCap panel in Premiere Pro': 'لوحة ArabCap داخل Premiere Pro',
};

export default components;
